import { useState } from "react";
import { Link } from "react-router-dom";
import { mediaVariant } from "../lib/catalogueApi";

// T59: Trusted brands. Icecat/staff logos (served from our media store) in equal tiles; brands without a logo keep their name.
// Phone: 3-column grid (all 12 visible, no hidden swipe); 640px+: 4 columns; 1024px+: 6 columns.
function Tile({ b }) {
  const [broken, setBroken] = useState(false);
  const logo = b.logo_media_id && !broken;
  return (
    <Link to={`/brands/${b.slug}`} data-testid={`home-brand-${b.slug}`} data-mark={logo ? "logo" : "name"}
      className="group flex h-16 items-center justify-center rounded-xl border border-slate-200 bg-white px-3 transition-[border-color,box-shadow] duration-200 hover:border-[var(--brand-accent)] hover:shadow-sm focus-visible:border-[var(--brand-accent)] motion-reduce:transition-none sm:h-[72px] sm:px-4">
      {logo ? (
        <img src={`${mediaVariant(b.logo_media_id, 320)}&trim=1`} alt={b.display_name} width="120" height="40" loading="lazy" decoding="async" onError={() => setBroken(true)}
          className="h-8 w-auto max-w-[85%] object-contain opacity-80 grayscale transition-[filter,opacity] duration-200 group-hover:opacity-100 group-hover:grayscale-0 group-focus-visible:opacity-100 group-focus-visible:grayscale-0 motion-reduce:transition-none sm:h-9" />
      ) : (
        <span className="text-center text-sm font-semibold leading-tight text-slate-600 group-hover:text-[var(--brand-primary)]">{b.display_name}</span>
      )}
    </Link>
  );
}

export function BrandTiles({ brands }) {
  return (
    <ul className="grid grid-cols-3 gap-2.5 sm:grid-cols-4 sm:gap-3 lg:grid-cols-6" data-testid="home-brand-tiles">
      {brands.map((b) => <li key={b.id}><Tile b={b} /></li>)}
    </ul>
  );
}
